import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=144bf87c&scoped=true&"
import script from "./PageMenu.vue?vue&type=script&lang=js&"
export * from "./PageMenu.vue?vue&type=script&lang=js&"
import style0 from "./PageMenu.vue?vue&type=style&index=0&id=144bf87c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144bf87c",
  null
  
)

export default component.exports